import { userRole } from "@/types/user";
import { ObjectId } from "@/types/object-id";
import { ApiEndpointBuilder } from "@/services/api/types";
import { usersApi } from ".";
import { isNullUUID } from "@/utils/data";
import { invitationsApi } from "@/store/invitations/endpoints";
import { PlanType } from "@/store/tenants/endpoints/tenants";

const addUser = (builder: ApiEndpointBuilder) => {
  return builder.mutation<string, Request>({
    query: ({ id, firstName, lastName, email, phoneNumber, userRoles, licenses }) => ({
      url: "/users",
      method: "POST",
      body: { id, firstName, lastName, email, phoneNumber, userRoles, licenses },
    }),
    async onQueryStarted(args, { queryFulfilled, dispatch }) {
      try {
        const { data } = await queryFulfilled;
        if (data && !isNullUUID(data)) {
          dispatch(
            usersApi.util.updateQueryData("searchUsers", {}, draftList => {
              draftList.data.unshift({
                ...args,
                roles: args.userRoles?.filter(role => role.enabled).map(role => role.roleName),
                licenses: args.licenses,
              });
            })
          );
        } else if (isNullUUID(data)) {
          dispatch(invitationsApi.util.invalidateTags(["usersInvitationsList"]));
        }
      } catch (error) {
        console.error(error);
      }
    },
    invalidatesTags: ["tenantDetails"],
  });
};

type Request = {
  id?: ObjectId;
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  userRoles?: userRole[];
  licenses: PlanType[];
};

export default addUser;
